import { Component, inject, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TooltipModule } from 'primeng/tooltip';
import { RippleModule } from 'primeng/ripple';
import { LucideAngularModule } from 'lucide-angular';
import { DiscoveryProgressComponent } from '../discovery-progress/discovery-progress.component';
import { TranslocoPipe } from '@jsverse/transloco';
import { PackLimitationsService } from '../../services/pack-limitations.service';
import { LimitedFeatures } from '../../models/pack.models';

@Component({
  selector: 'app-discovery-indicator',
  standalone: true,
  imports: [
    CommonModule,
    TooltipModule,
    RippleModule,
    LucideAngularModule,
    DiscoveryProgressComponent,
    TranslocoPipe,
  ],
  templateUrl: './discovery-indicator.component.html',
  styleUrls: ['./discovery-indicator.component.scss'],
})
export class DiscoveryIndicatorComponent {
  @Input() isCollapsed: boolean = false;

  private packLimitationService = inject(PackLimitationsService);

  discoveryStatus = this.packLimitationService.isDiscovery;

  /**
   * Récupère le format d'affichage pour le badge collapsed (ex: "1/2")
   */
  get displayCount(): string {
    const status = this.discoveryStatus();
    if (!status) return '0/1';

    const used = this.packLimitationService.currentNumberOfTrips();
    const limit = this.packLimitationService.tripLimit();

    return `${used}/${limit}`;
  }

  /**
   * Vérifie si la limite est atteinte
   */
  get isLimitReached(): boolean {
    const status = this.discoveryStatus();
    if (!status) return false;

    const used = this.packLimitationService.currentNumberOfTrips();
    const limit = this.packLimitationService.tripLimit();

    return used >= limit;
  }

  /**
   * Gère le clic sur l'indicateur collapsed
   */
  handleClick(): void {
    this.openContactModal();
  }

  /**
   * Ouvre la modale de contact
   */
  openContactModal(): void {
    this.packLimitationService.openModal(LimitedFeatures.Trip);
  }
}
